module.exports = __webpack_public_path__ + "static/revenus-0b389ba4d2e3c3f00c56ce32c53d7f80.svg";